import CTAButton from '../components/CTAButton';
import useDocumentTitle from '../hooks/useDocumentTitle';

const servicesHeroImg = require('../Assert/10.jpg');

function Services() {
  useDocumentTitle('Services — MMI');

  return (
    <main className="services-page">
      {/* Hero Section - No MMI Badge */}
      <section className="services-hero">
        <div className="container">
          <div className="services-hero-grid">
            <div className="services-hero-text">
              <h1 className="hero-title">
                We Build the <span className="gradient-text">Hard Stuff.</span>
              </h1>
              <p className="hero-description">
                Agentic AI. Immersive tech. Intelligent systems. 
                <br />
                If it pushes what's possible — it's what we do.
              </p>
            </div>
            <div className="services-hero-media">
              <div className="assert-image-wrap">
                <img src={servicesHeroImg} alt="MMI services" className="assert-image" />
                <div className="assert-image-glow" aria-hidden="true" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services List Section - Numbered */}
      <section className="services-list-section">
        <div className="container">
          <div className="services-container">
            
            {/* Service 01 */}
            <div className="service-item">
              <div className="service-number">01</div>
              <div className="service-content">
                <h3 className="service-title">Agentic AI Development</h3>
                <p className="service-description">
                  Autonomous entities capable of complex reasoning and goal-setting.
                </p>
              </div>
            </div>

            {/* Service 02 */}
            <div className="service-item">
              <div className="service-number">02</div>
              <div className="service-content">
                <h3 className="service-title">AI Automation</h3>
                <p className="service-description">
                  Streamlining enterprise operations with intelligent workflows.
                </p>
              </div>
            </div>

            {/* Service 03 */}
            <div className="service-item">
              <div className="service-number">03</div>
              <div className="service-content">
                <h3 className="service-title">AR/VR Development</h3>
                <p className="service-description">
                  Blurring the line between physical and digital spaces.
                </p>
              </div>
            </div>

            {/* Service 04 */}
            <div className="service-item">
              <div className="service-number">04</div>
              <div className="service-content">
                <h3 className="service-title">Meta Applications</h3>
                <p className="service-description">
                  High-fidelity spatial computing and obsidian-grade neural interfaces.
                </p>
              </div>
            </div>

            {/* Service 05 */}
            <div className="service-item">
              <div className="service-number">05</div>
              <div className="service-content">
                <h3 className="service-title">UI/UX Design</h3>
                <p className="service-description">
                  Precision-engineered interfaces designed for speed and scalability.
                </p>
              </div>
            </div>

            {/* Service 06 */}
            <div className="service-item">
              <div className="service-number">06</div>
              <div className="service-content">
                <h3 className="service-title">Custom Software Development</h3>
                <p className="service-description">
                  Engineering high-fidelity digital experiences using a future-focused technology stack.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="services-cta">
        <div className="container">
          <div className="cta-box">
            <h2 className="cta-title">
              Ready to <span className="gradient-text">make it real?</span>
            </h2>
            <CTAButton text="Book a Call" to="/contact" />
          </div>
        </div>
      </section>

      
    </main>
  );
}

export default Services;